import { Button, TextField, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import CustTable from '../comp/custtable/custtable';
import RefreshIcon from '@mui/icons-material/Refresh';
import BrandAdd from './brandadd';
import BrandMod from './brandmod';

const Brands = ({ token }) => {
    const [items, setItems] = useState([]);
    const [[start, end], setSEnd] = useState([0, 20])
    const [sstr, setSearch] = useState("");
    const [sdiscount, setSdiscount] = useState("");
    const [allcont, setAllCount] = useState(0);
    const [loading, setLoad] = useState(true);
    const [addmodal, setAddModal] = useState(false);
    const [modmodal, setModModal] = useState(false);
    const [custrow, setcustrow] = useState([]);
    
    

    const brandnameref = useRef();

    const columns = [
        { field: 'id', headerName: 'Дугаар', },
        { field: 'brand_name', headerName: 'Брэнд нэр', width: 200 },
        { field: 'brand_bonus_prcnt', headerName: 'Брэнд хямдрал хувь', width: 200 },
        { field: 'brand_bonus_unit', headerName: 'Брэнд хямдрал тоо', width: 200 },
        
    ];

    const rowClick = (e) => {

        setcustrow(e);
        setModModal(true);

    }

    useEffect(() => {
        var url = 'https://wms-cloud.com/api/Brand?_start='+start+'&_end='+end;
        //var url = 'http://localhost:8080/Brand?_start='+start+'&_end='+end;
        if(sstr!="")
        {
            url=url+'&brand_name=' + sstr;
        }
        if(sdiscount!="")
        {
            url=url+'&discount_flg=' + sdiscount;
        }
        const request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Access-Control-Allow-Headers': 'X-Total-Count'
            })
        });
        fetch(request).then(
            (response) => {
                if (response.status == 200) {
                    console.log(response.headers.get('X-Total-Count'));
                    setAllCount(response.headers.get('X-Total-Count'));
                    return response.json();
                } else if (response.status == 500) {
                    alert("Алдаа гарлаа дахин оролдоно уу.");
                } else {
                    localStorage.removeItem('tok');
                    window.location.reload(false);
                    alert("Алдаа гарлаа.")
                }
            }
        ).then((resp) => {
            setItems(resp);
            setLoad(false);
        });

    }, [start, end, sstr, sdiscount])

    const handlePage = (e) => {
        console.log('aaaa: '+e);
        setLoad(true);
        setSEnd([e * 20, (e * 20) + 20]);
    }

    const handlediscountChange = (e) => {
            setLoad(true);
            setSdiscount(e.target.value);
        }

    const brandnameChange = (e) =>{
        if (e.keyCode == 13) {
        setSearch(brandnameref.current.value);
        }
    }
    const custRefresh = () => {
        window.location.reload(false);
    }



    return <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <div className="parenthead">
            <div>
                <h3>Брэнд</h3>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <TextField inputRef={brandnameref} size="small" label="Нэрээр хайх" onKeyDown={brandnameChange} />
                <FormControl size="small" sx={{ width: 180 }}>
                    <InputLabel id="brand-discount-label">Хямдралтай эсэх</InputLabel>
                    <Select
                        fullWidth
                        labelId="brand-discount-label"
                        value={sdiscount}
                        label="Хямдралтай эсэх"
                        onChange={handlediscountChange}
                    >
                        <MenuItem key={"Y"} value={"Y"}>{"Хямдралтай"}</MenuItem>
                        <MenuItem key={"N"} value={"N"}>{"Бүгд"}</MenuItem>
                    </Select>
                </FormControl>
                <Button style={{ height: "40px" }} variant="outlined" onClick={setAddModal} >Брэнд үүсгэх</Button>
                <Button variant="outlined" style={{ height: "40px" }} onClick={() => {
                    window.location.reload(false);
                }}> <RefreshIcon /> </Button>
            </div>
        </div>
        <div className="tablecont">
            <CustTable
                name={"Brands"}
                columns={columns}
                items={items}
                allcont={allcont}
                handlePage={handlePage}
                rowClick={rowClick}
                loading={loading} />
        </div>
        {addmodal ?
        <BrandAdd handleClose={setAddModal}
        token={token}
        open={addmodal}
        handleRefresh={custRefresh}
        handleModal={setAddModal} /> : <></>
        }
        {modmodal ?
        <BrandMod handleClose={setModModal}
        token={token}
        open={modmodal}
        custrow={custrow}
        handleRefresh={custRefresh}
        handleModal={setModModal} /> : <></>
        }
    </div>

}

export default Brands;